module.exports = __webpack_public_path__ + "files/c169a765d072f405340bea3039f79c40.png";